export default __webpack_public_path__ + "static/media/grow.05ce3c68.svg";